import React from 'react'

const RightArrowIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    className="lucide lucide-chevron-right h-[15px] w-[15px]">
    <path d="m9 18 6-6-6-6"></path>
</svg>
  )
}

export default RightArrowIcon